import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Introduce {
  name: string;
  api_token: string;
}

export interface IntroduceDetaiInfor {
  errors: unknown;
  Introduce: Introduce;
  isAuthenticated: boolean;
}

@Module
export default class IntroduceDetail
  extends VuexModule
  implements IntroduceDetaiInfor
{
  errors = {};
  Introduce = {} as Introduce;
  isAuthenticated = !!JwtService.getToken();
  /**
   * Get current user object
   * @returns User
   */
  get IntroduceDetail() {
    return this.introduceDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.INTRODUCE_DETAIL_DATA](Introduce) {
    this.introduceDetailData = Introduce;
  }
  @Action
  [Actions.INTRODUCE_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/introduce",
      payload["id"],
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.INTRODUCE_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.INTRODUCE_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/introduce", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.INTRODUCE_DETAIL_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
